const {registerBlockType, registerBlockStyle} = wp.blocks
import String from './utils/String'
import Controls from './Controls'

/**
 * BlockType
 * 
 * @returns {BlockType}
 */
export default class BlockType {
    /**
     * Constructor
     * 
     * @param {object} options
     */
    constructor(options) {
        if (! options || ! options.component) {
            throw 'BlockType requires component'
        }

        this.component = options.component

        delete options.component
        this.options = options
    }

    /**
     * BlockType Block within WordPress Gutenberg
     */
    register() {
        // Register Controls
        Controls.register(this.getName(), this.getControls())

        // Register Block
        registerBlockType(this.getName(), this.getRegisterParameters())

        // Register Styles
        this.getStyles().forEach(style => registerBlockStyle(this.getName(), style))
    }

    /**
     * Get BlockType Parameters for WordPress Gutenberg
     * 
     * @return {object}
     */
    getRegisterParameters() {
        return {
            title: this.getTitle(),
            icon: this.getIcon(),
            category: this.getCategory(),
            example: this.getExample(),
            attributes: this.getAttributes(),
            supports: this.getSupports(),
            edit: this.getComponent(),
            save: this.getComponent(),
        }
    }

    /**
     * Get Block React Component
     * 
     * @return {Component|function}
     */
    getComponent() {
        return this.component
    }

    /**
     * Get Block Name
     * 
     * @return {string}
     */
    getName() {
        if (this.component.getName) return this.component.getName()

        return this.getNamespace() +'/'+ String.kebabCase(this.getTitle())
    }

    /**
     * Get Block Namespace
     * 
     * @return {string}
     */
    getNamespace() {
        if (this.options.namespace) return this.options.namespace
        if (this.component.getNamespace) return this.component.getNamespace()
        return this.getCategory()
    }

    /**
     * Get Block Category
     * 
     * @return {string}
     */
    getCategory() {
        if (this.options.category) return this.options.category
        if (this.component.getCategory) return this.component.getCategory()
        return 'common'
    }

    /**
     * Get Block Title
     * 
     * @return {string}
     */
    getTitle() {
        if (this.options.title) return this.options.title
        if (this.component.getTitle) return this.component.getTitle()
        return 'Block'
    }

    /**
     * Get Block Icon
     * 
     * @return {string}
     */
    getIcon() {
        if (this.options.icon) return this.options.icon
        if (this.component.getIcon) return this.component.getIcon()
        return 'carrot'
    }

    /**
     * Get Block Example data
     * 
     * @return {object}
     */
    getExample() {
        if (this.options.example) return this.options.example
        if (this.component.getExample) return this.component.getExample()
        return {attributes: {}}
    }

    /**
     * Get Block Attributes data
     * 
     * @return {object}
     */
    getAttributes() {
        if (this.options.attributes) return this.options.attributes
        if (this.component.getAttributes) return this.component.getAttributes()
        return {}
    }

    /**
     * Get Block Supports data
     * 
     * @return {object}
     */
    getSupports() {
        if (this.options.supports) return this.options.supports
        if (this.component.supports) return this.component.supports()
        return {}
    }

    /**
     * Get Block Styles
     * 
     * @return {object}
     */
    getStyles() {
        if (this.options.styles) return this.options.styles
        if (this.component.styles) return this.component.styles()
        return []
    }

    /**
     * Get Block Controls
     * 
     * @return {object}
     */
    getControls() {
        if (this.options.controls) return this.options.controls
        if (this.component.controls) return this.component.controls()
        return []
    }
}